import { render, staticRenderFns } from "./ClassroomBody.vue?vue&type=template&id=ec80d59a&"
import script from "./ClassroomBody.vue?vue&type=script&lang=js&"
export * from "./ClassroomBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports